import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  isLive: PropTypes.bool, // 是否为直播模式
  liveUrl: PropTypes.string,
  poster: PropTypes.string,
  appName: PropTypes.string.isRequired, // 腾讯直播的AppName
  streamName: PropTypes.string.isRequired, // 腾讯直播的StreamName
  params: PropTypes.string.isRequired, // 直播其他参数
  endLive: PropTypes.bool,
};

// 直播组件
function Live(props) {
  const {
    appName, isLive, liveUrl, params, poster, streamName, endLive,
  } = props;
  React.useEffect(() => {
    const basePath = `${liveUrl}/${appName}/${streamName}`;
    console.log({
      m3u8_hd: basePath.concat('_900.m3u8'),
      live: isLive,
      autoplay: true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
      poster,
      coverpic: { style: 'cover', src: '' },
      width: '100%', // 视频的显示宽度，请尽量使用视频分辨率宽度
      height: 'auto', // 视频的显示高度，请尽量使用视频分辨率高度
      clarity: 'hd',
      pausePosterEnabled: false,
      systemFullscreen: false,
      x5_player: false,
      x5_type: 'h5',
      x5_playsinline: true,
      x5_fullscreen: false,
      wording: {
        0: '请求视频失败，请检查网络',
        13: '直播已结束，请稍后再来。',
        5: '',
        2032: '请求视频失败，请检查网络',
        2048: '请求m3u8文件失败，可能是网络错误或者跨域问题',
        2: '直播已结束，请稍后再来。',
      },
      clarityLabel: { od: '蓝光', hd: '高清', sd: '标清' },
      listener: () => {
        const videoHeight = document.querySelector('#live').offsetHeight;
        // eslint-disable-next-line react/prop-types
        props.onValue(videoHeight);
      },
    });
    const livePlayer = endLive
      && new TcPlayer('live', {
        m3u8_hd: basePath.concat('_900.m3u8'),
        live: isLive,
        autoplay: true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        poster,
        coverpic: { style: 'cover', src: '' },
        width: '100%', // 视频的显示宽度，请尽量使用视频分辨率宽度
        height: 'auto', // 视频的显示高度，请尽量使用视频分辨率高度
        clarity: 'hd',
        pausePosterEnabled: false,
        systemFullscreen: false,
        x5_player: false,
        x5_type: 'h5',
        x5_playsinline: true,
        x5_fullscreen: false,
        wording: {
          0: '请求视频失败，请检查网络',
          13: '直播已结束，请稍后再来。',
          5: '',
          2032: '请求视频失败，请检查网络',
          2048: '请求m3u8文件失败，可能是网络错误或者跨域问题',
          2: '直播已结束，请稍后再来。',
        },
        clarityLabel: { od: '蓝光', hd: '高清', sd: '标清' },
        listener: () => {
          const videoHeight = document.querySelector('#live').offsetHeight;
          // eslint-disable-next-line react/prop-types
          props.onValue(videoHeight);
        },
      });
    console.log('livePlayer', livePlayer);
    return () => {
      console.log('zhibo', poster);
      if (livePlayer) livePlayer.destroy();
      return true;
    };
    // eslint-disable-next-line
  }, [appName, isLive, liveUrl, params, poster, streamName, endLive]);

  return <div id="live" style={{ width: '100%', height: 'auto' }} />;
}

Live.propTypes = propTypes;

Live.defaultProps = {
  isLive: true,
  liveUrl: '',
  poster: '',
  endLive: false,
};

export default Live;
